<template>
    <div class="professional-summary">
        <!-- <div class="heading2-section">
            Professional Summary
        </div> -->
    <form @submit.prevent="updateSummary">
   
        <div class="form-floating">
            <div ref="editor" class="custom-quill"></div>
        </div>
        
        <div class="form-buttons mb-3">
            <button type="submit" class="btn btn-default primary-btn" v-if="loading" disabled>Saving Summary...</button>
            <button type="submit" class="btn btn-default primary-btn" v-else>Save</button>
        </div>
         <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form>
    <LoadingIndicator v-if="loading"/>
    </div>
    <CustomConfirmationMessageModal :title="modal.caption"
            ref="summaryConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import { updateSummaryAsync } from '@/services/cvbuilderService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
export default {
    components:{
        LoadingIndicator, CustomConfirmationMessageModal
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            user:{
                    summary:"",       
                },
            modal:{
                caption:"",
                message:""
            },
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"updateSummary"          
        }
    },
      mounted(){
        
        const cv = this.$store.getters["cvbuilder/getCVInformation"];
        this.user.summary = cv?.professionalSummary || "";
        this.setupQuill();



    },
     methods:{
    setupQuill(){
                // Initialize Quill
            this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            modules: {
                toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link']
                ]
            }
            });
            //set present values
            this.quill.root.innerHTML = this.user.summary;

            // Listen for changes and update Vue data
            this.quill.on('text-change', () => {
            this.user.summary = this.quill.root.innerHTML
            })
    },
     async updateSummary(){
        try{
            this.resetOnNewSubmit();
            var data = await updateSummaryAsync(this.user);
            this.loading = false;
            if(data.success){
                var cv = {
                    professionalSummary: this.user.summary
                };
                await this.$store.dispatch('cvbuilder/updateCVInformationAsync', cv);
                // this.modal.caption = data.caption;
                // this.modal.message = data.message;
                // this.showModal();
        }else{
            if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                this.clearErrors();
                return;
            }
           
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try later";
            this.errors.push(message);
            this.hasErrors = true;
            this.clearErrors();
                  
        }     
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        closeModal(){
        if (this.$refs.summaryConfirmModal && typeof this.$refs.summaryConfirmModal.hide === 'function') {
        this.$refs.summaryConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.summaryConfirmModal.show();
        },
        clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }
   }
}
</script>
<style scoped>
    .custom-quill.ql-container.ql-snow{
        background-color: var(--editor-background2)!important;
        color:var(--foreground);
    }

    .professional-summary{
        padding-top:1rem;
    }
</style>